(function oscMain(window, document) {
    'use strict';

    const LOG_OSC = '[ODOSCOPE]',
        KEY_OSC = 'odoscope',
        OSC_OFF = 'odoscope is turned off';


    if (!window.Osc_ENV) {
        window.console.warn(LOG_OSC, `"Osc_ENV" is not defined: ${OSC_OFF}`);
        return;
    }


    const SITE_ID = String(window.Osc_ENV.site_id).trim(),
        DECISION_TOKEN = String(window.Osc_ENV.token).trim(),
        AB_TEST_RATIO = Number(window.Osc_ENV.ab_test_ratio);


    var _msg = null;

    if (SITE_ID.length == 0) {
        _msg = '"Osc_ENV.site_id" is empty';
    }
    else if (DECISION_TOKEN.length == 0) {
        _msg = '"Osc_ENV.token" is empty';
    }
    else if (Number.isNaN(AB_TEST_RATIO)) {
        _msg = '"Osc_ENV.ab_test_ratio" is not a number';
    }

    if (_msg != null) {
        window.console.error(LOG_OSC, `${_msg}: ${OSC_OFF}`);

        _msg = null;
        return;
    }

    if (!window.Osc_ENV.turn_on_osc) {
        window.console.warn(LOG_OSC, OSC_OFF);
        return;
    }

    (function addEnglishOptionNameFallbacks() {
        var env = window.Osc_ENV;
        if (!env || !Array.isArray(env.visual_options)) return;

        var englishNames = [
            { en: 'Color', index: 0 },
            { en: 'Motive', index: 1 }
        ];

        for (var i = 0; i < englishNames.length; i++) {
            var entry = englishNames[i];
            var translatedName = env.visual_options[entry.index];

            if (!translatedName) continue;
            if (env.visual_options.indexOf(entry.en) !== -1) continue;

            env.visual_options.push(entry.en);

            if (env.option_labels) {
                env.option_labels[entry.en] = translatedName;
            }
        }
    })();

    /* Debug panel */
    (function (window, document) {

        var OSC = window.Osc;

        OSC.injectDebugPopup = function () {
            var RNDR_SELECTOR = '.rndr',
                TRCK_SELECTOR = '.trck',
                ON_CLASS = 'on',
                OFF_CLASS = 'off',
                LOADING_CLASS = 'loading';

            var OSC_SELECTOR = '.block.osc',
                PRD_SELECTOR = '.block.prd';

            var popupCSS = '.osc-dbg-line { position: fixed; top: 0; left: 0; right: 0;height: 24px;' +
                ' background-color: #009EE0; color: white; z-index: 100000; opacity: 0.8; }' +
                ' .osc-dbg-line.loading .block:not(.vv) {visibility: hidden;}' +
                ' .osc-dbg-line.off .block:not(.vv):not(.osc) {visibility: hidden;}' +
                ' .osc-dbg-line .red {color: red;}' +
                ' .osc-dbg-line .block {display: inline-block;margin-right: 20px;}' +
                ' .osc-dbg-line .block.on span:first-child {display: inline;}' +
                ' .osc-dbg-line .block.on span:last-child {display: none;}' +
                ' .osc-dbg-line .block.on.osc span:first-child + span {display: none;}' +
                ' .osc-dbg-line .block.on.control.osc span:first-child {display: inline;}' +
                ' .osc-dbg-line .block.on.control.osc span:last-child {display: none;}' +
                ' .osc-dbg-line .block.on.control.osc span:first-child + span {display: inline;}' +
                ' .osc-dbg-line .block.off span:first-child {display: none;}' +
                ' .osc-dbg-line .block.off span:last-child {display: inline;}' +
                ' .osc-dbg-line .block.off span:first-child + span {display: none;}' +
                ' .osc-dbg-line .decision-link {display:none;}' +
                ' .osc-dbg-line .decision-link.visible {display:inline;}' +
                ' .osc-dbg-line .rndr {color:lightgreen;}' +
                ' .osc-dbg-line .rndr.off {color:lightsalmon; text-decoration: 1px solid line-through;}' +
                ' .osc-dbg-line .trck {color:lightgreen;}' +
                ' .osc-dbg-line .trck.off {color:lightsalmon; text-decoration: 1px solid line-through;}',
                head = document.head || document.getElementsByTagName('head')[0],
                body = document.body || document.getElementsByTagName('body')[0],
                styleNode = document.createElement('style'),
                popupText = "",
                url = window.location.protocol + '//' + window.location.host + window.location.pathname;

            var popupNode = document.createElement('div');

            styleNode.type = 'text/css';
            if (styleNode.styleSheet) {
                styleNode.styleSheet.cssText = popupCSS;
            } else {
                styleNode.appendChild(document.createTextNode(popupCSS));
            }

            popupNode.classList.add('osc-dbg-line');
            popupNode.classList.add(LOADING_CLASS);

            popupText += '&nbsp;' +
                '<div class="block vv"><span>v.' + window.oscScriptVersion + '</span></div>' +
                '<div class="block osc"><span style="color:lime;">odoscope on</span><span style="color:lightsalmon;margin-left: 0.5rem;">CONTROL</span><span style="color:lightgray;">odoscope off</span></div>' +
                '<div class="block"><a class="decision-link" href="#">decision link</a></div>' +
                '<div class="block prd"><span class="prd-count">[<i>...</i>] items</span><span class="prd-empty red">EMPTY</span></div>' +
                '<div class="block"><span class="rndr">Rendering</span><span>|</span><span class="trck">Tracking</span></div>' +
                '<span class="cookie-links" style="float: right;">' +
                '<a href="' + url + '?osc=1" style="color: lime;">dice->1</a>&nbsp;&nbsp;<a href="' + url + '?osc=99" class="red">dice->99</a>' +
                '</span>';

            popupNode.innerHTML = popupText;

            head.appendChild(styleNode);
            body.appendChild(popupNode);

            return {
                unload: function () {
                    head.removeChild(styleNode);
                    body.removeChild(popupNode);
                },
                turnOscOn: function () {
                    popupNode.querySelector(OSC_SELECTOR).classList.add(ON_CLASS);
                    popupNode.classList.add(ON_CLASS);
                    popupNode.classList.remove(LOADING_CLASS);
                },
                switchToControl: function () {
                    popupNode.querySelector(OSC_SELECTOR).classList.add('control');
                },
                turnOscOff: function () {
                    popupNode.querySelector(OSC_SELECTOR).classList.add(OFF_CLASS);
                    popupNode.classList.add(OFF_CLASS);
                    popupNode.classList.remove(LOADING_CLASS);
                },

                setDecisionLink: function (decisionLink) {
                    let decisionLinkNode = popupNode.querySelector('.decision-link');

                    decisionLinkNode.classList.add('visible');
                    decisionLinkNode.href = decisionLink;
                },

                setProductsCount: function (productsCount) {
                    popupNode.querySelector('.prd-count i').innerHTML = productsCount;

                    let container = popupNode.querySelector(PRD_SELECTOR);
                    container.classList.add(ON_CLASS);
                    container.classList.remove(OFF_CLASS);
                },
                setNoProducts: function () {
                    let container = popupNode.querySelector(PRD_SELECTOR);
                    container.classList.add(OFF_CLASS);
                    container.classList.remove(ON_CLASS);
                },

                renderingOn: function () {
                    popupNode.querySelector(RNDR_SELECTOR).classList.remove(OFF_CLASS);
                },
                renderingOff: function () {
                    popupNode.querySelector(RNDR_SELECTOR).classList.add(OFF_CLASS);
                },
                trackingOn: function () {
                    popupNode.querySelector(TRCK_SELECTOR).classList.remove(OFF_CLASS);
                },
                trackingOff: function () {
                    popupNode.querySelector(TRCK_SELECTOR).classList.add(OFF_CLASS);
                }
            };
        };

        OSC.checkDebugFlags = function (instance, cookieDicePrefix) {
            let params = new window.URLSearchParams(window.location.search);

            if (params.has('osc')) {
                let value = Number(params.get('osc'));

                if (!Number.isNaN(value)) {
                    instance.cookie(cookieDicePrefix + instance._config.token, value);
                }
            }

            if (params.has('oscadmin')) {
                instance.cookie('oscAdmin', '1');
            }
        };


        OSC.isDebugTurnedOn = function (instance) {
            return (instance.cookie('oscAdmin') == '1');
        };

    })(window, document);


    const oscClient = window.Osc_client,
        Alpine = window.Alpine;

    var debugPanel = null;
    var context = this;

    var templates = {};
    /** @type {Array|null} */
    var availableCustomFilters = null;


    /* check the debug panel */
    if (window.Osc.injectDebugPopup != void 0) {
        window.Osc.checkDebugFlags(oscClient, oscClient.COOKIE_DICE_PREFIX);

        if (window.Osc.isDebugTurnedOn(oscClient)) {
            debugPanel = window.Osc.injectDebugPopup();

            debugPanel.trackingOn();
        }
    }

    /* some export fn */
    oscClient.getQuantityMsg = function (count) {
        return window.Osc_ENV.msg_low_quantity.replace('999', count);
    };

    oscClient.checkOdoscopeStates = function () {
        if (oscClient.turned_off) {
            if (debugPanel) {
                debugPanel.renderingOff();
                debugPanel.trackingOff();
                debugPanel.turnOscOff();
            }

            return false;
        }

        if (oscClient.is_control) {
            pushTrackingEvent('control', DECISION_TOKEN);

            if (debugPanel) {
                debugPanel.switchToControl();
                debugPanel.turnOscOff();
            }

            return false;
        }

        if (!oscClient.navigator.isProperSortingUsed) {
            pushTrackingEvent('AddSort', DECISION_TOKEN + '/' + oscClient.navigator.sortBy);

            if (debugPanel) {
                debugPanel.renderingOff();
            }

            return false;
        }

        if (debugPanel) {
            debugPanel.renderingOn();
        }

        return true;
    };


    /* self run */
    requestAnimationFrame(function waitForTargetNode() {
        let target = oscClient.getTargetNode();

        if (target) {
            templates.product = document.getElementById('osc-product-item');

            availableCustomFilters = getPossibleFilterNames();

            if (oscClient.checkOdoscopeStates()) {
                applyOdoscopeSorting_OnStartup(target);
            }

            subscribeEvents();
            return;
        }

        requestAnimationFrame(waitForTargetNode);
    });


    const P_ALPINE_ID = '#ALPINE_ID#';
    const DIVIDER = ',';

    const VARIANT_LIMIT = 4,
        PRELOAD_LIMIT = 6,
        PRODUCT_PER_PAGE = 36;

    const FILTER_COLLECTION = 'cr_collection_ids',
        PARAMETER_COLLECTION = 'cp_collection_handle',
        CUSTOM_PRODUCT_FILTER_PREFIX = 'filter.p.m.custom.',
        CUSTOM_VARIANT_FILTER_PREFIX = 'filter.v.m.custom.',
        BUILT_IN_FILTER_PREFIX = 'filter.',
        FILTER_MAP = {
            'filter.v.price.gte': 'minprice',// >= price
            'filter.v.price.lte': 'maxprice',// <= price
            'filter.v.option.size': 'cr_size'
        };

    /** @type {Array.<String>|null} */
    var ALPINE_IDS = null;

    var PRODUCT_LIST_STATE = {
        current: -1,
        total: -1,
        filtersApplied: false,
        $stage: -1
    };



    function collectOdoscopeParams() {
        let params = {
            maxItems: PRODUCT_PER_PAGE
        };

        let query = oscClient.navigator.query;

        let currentLanguage = resolveCurrentLanguage();
        if (currentLanguage) {
            params.lang = currentLanguage;
        }

        collect_filter_collection(params);

        PRODUCT_LIST_STATE.filtersApplied = collect_common_filters(params, query);
        PRODUCT_LIST_STATE.filtersApplied = collect_product_specific_filters(params, query) || PRODUCT_LIST_STATE.filtersApplied;

        return params;
    }

    function guardExecution(callback) {
        return function internal_guardExecution(products, additionalInfo, oscTracking) {
            try {
                callback.call(context, products, additionalInfo);
            }
            catch (error) {
                window.console.error(LOG_OSC, 'Execution error:', error);
                
                if (debugPanel) {
                    debugPanel.setNoProducts();
                    debugPanel.renderingOff();
                }

                ALPINE_IDS = null;

                revealProductCards();

                pushTrackingEvent(`${KEY_OSC}/ScriptError`, oscTracking);
            }
        };
    }

    function requestDecisionWithLanguageFallback(params, successCallback, failureCallback) {
        decision(oscClient, params)(successCallback, failureCallback);
    }

    function applyOdoscopeSorting_OnStartup(productsContainer) {
        let params = collectOdoscopeParams();

        requestDecisionWithLanguageFallback(params,
            guardExecution(
                function success(products, additionalInfo) {
                    ALPINE_IDS = placeProductsToStorage(products);

                    updateCounter(additionalInfo);

                    rebuildProductWall(productsContainer);

                    revealProductCards();

                    if (debugPanel) debugPanel.turnOscOn();

                    replaceLoadMoreHandler();
                    updateUICounters();
                }
            ),
            function failed() {
                ALPINE_IDS = null;

                revealProductCards();

                if (debugPanel) debugPanel.turnOscOn();
            }
        );
    }


    function beginOdoscopeSorting() {
        ALPINE_IDS = null;

        if (!oscClient.checkOdoscopeStates()) return;

        let $stage = Date.now();

        oscClient.conceal();

        let params = collectOdoscopeParams();

        requestDecisionWithLanguageFallback(params,
            guardExecution(
                function success(products, additionalInfo) {
                    ALPINE_IDS = placeProductsToStorage(products);

                    updateCounter(additionalInfo);

                    if (debugPanel) debugPanel.turnOscOn();

                    if (PRODUCT_LIST_STATE.$stage >= $stage) endOdoscopeSorting();
                }
            ),
            function failed() {
                ALPINE_IDS = null;

                revealProductCards();

                if (debugPanel) debugPanel.turnOscOn();
            }
        );
    }

    function endOdoscopeSorting() {
        PRODUCT_LIST_STATE.$stage = Date.now();

        if (ALPINE_IDS == null) return;

        let target = oscClient.getTargetNode();

        rebuildProductWall(target);

        replaceLoadMoreHandler();
        updateUICounters();

        revealProductCards();
    }


    function loadMoreOdoscope() {
        let target = oscClient.getTargetNode();
        let productList = findProductListNode(target);
        
        if (!productList) {
            window.console.error(LOG_OSC, 'Product list container not found!');
            return;
        }

        let list_existed_nodes = getRenderedProducts(productList);
        let params = collectOdoscopeParams();

        if (Array.isArray(list_existed_nodes) && list_existed_nodes.length > 0) {
            params.offset = list_existed_nodes.length;
        }

        requestDecisionWithLanguageFallback(params,
            guardExecution(
                function success(products, additionalInfo) {
                    ALPINE_IDS = placeProductsToStorage(products);

                    PRODUCT_LIST_STATE.current = (params.offset || 0) + ALPINE_IDS.length;

                    extendProductWall(productList);

                    updateUICounters();

                    // Hide load more button if all products are loaded
                    if (PRODUCT_LIST_STATE.current >= PRODUCT_LIST_STATE.total) {
                        let button = target.querySelector('[data-load-more="button"]');
                        if (button) button.style.display = 'none';
                    }

                    if (debugPanel) debugPanel.turnOscOn();
                }
            ),
            function failed() {
                window.console.error(LOG_OSC, 'Decision failed or goControl triggered.');
                ALPINE_IDS = null;

                if (debugPanel) debugPanel.turnOscOn();
            }
        );
    }


    function subscribeEvents() {
        document.addEventListener('liquify:before-render', beginOdoscopeSorting);
        document.addEventListener('liquify:sections-rendered', endOdoscopeSorting);
    }


    /**
     * Return a function executing a decision endpoint request for CATEGORIES
     * @param {Object} instance Osc client library instance
     * @param {Object} params decision parameters
     */
    function decision(instance, params) {
        return function (decisionCallback, failureCallback) {
            let referrer = externalReferrer();
            if (referrer) params.ref = referrer;

            oscCookies(instance, function cookies_handler(cookie_token, value) {
                params[oscClient.COOKIE_TRCK_PREFIX + cookie_token] = value;
            });

            instance.decision(params, function successDecision(data) {
                if (debugPanel) debugPanel.setDecisionLink(instance.lastDecisionUrl);

                if (typeOf(data.oscCookie) == "object") {
                    for (let prop in data.oscCookie) {
                        if (!data.oscCookie.hasOwnProperty(prop)) continue;

                        instance.cookie(prop, data.oscCookie[prop]);
                    }
                }


                if (!!data.goControl) {
                    if (debugPanel) {
                        debugPanel.setProductsCount(0);
                        debugPanel.switchToControl();
                    }

                    pushTrackingEvent(KEY_OSC, data.oscTracking);

                    failureCallback();
                }
                else if (Array.isArray(data.variants) && data.variants.length > 0) {
                    if (debugPanel) debugPanel.setProductsCount(data.variants.length);

                    pushTrackingEvent(KEY_OSC, data.oscTracking);

                    decisionCallback.call(
                        context,
                        data.variants.slice(0, params.maxItems),
                        data.additionalInfo,
                        data.oscTracking
                    );
                }
                else {
                    if (debugPanel) {
                        debugPanel.setNoProducts();
                        debugPanel.renderingOff();
                    }

                    pushTrackingEvent(`${KEY_OSC}/empty`, data.oscTracking);

                    failureCallback();
                }

            }, function failedDecision(reason) {
                if (reason == "TIMEOUT") {
                    pushTrackingEvent(`${KEY_OSC}/timeout`, DECISION_TOKEN);
                }
                else {
                    pushTrackingEvent(`${KEY_OSC}/error`, DECISION_TOKEN);
                }

                failureCallback.call(context);
            });
        };
    }

    /**
     * @param {Array.<Object>} products
     * @return {Array.<String>}
     */
    function placeProductsToStorage(products) {
        let output = [];
        let images = [];

        for (let j_product of products) {
            let product = OscProduct.parseJsonRecord(j_product);
            let alpine_id = product.getAlpineID();

            output.push(alpine_id);

            Alpine.data(alpine_id, () => (product));


            if (product.selected_or_first_available_variant != null && images != null) {
                if (images.length < PRELOAD_LIMIT) {
                    images.push(product.selected_or_first_available_variant.image.url);
                }
                else {
                    preloadImages(images);
                    images = null;
                }
            }
        }

        if (images != null && images.length > 0) {
            preloadImages(images);
        }

        return output;
    }

    function updateCounter(additionalInfo) {
        PRODUCT_LIST_STATE.current = Math.min(additionalInfo.totalObjectsCount, PRODUCT_PER_PAGE);
        PRODUCT_LIST_STATE.total = getTotalProductNumber();
    }


    function findProductListNode(productsContainer) {
        return productsContainer.querySelector('.filter_product-list, [data-load-more="list"]');
    }

    function getRenderedProducts(productList) {
        let items = Array.from(productList.querySelectorAll(':scope > .filter_product-list-item'));
        if (items.length === 0) {
            // Fallback to all element children if the specific class is not found
            items = Array.from(productList.children).filter(el => el.nodeType === 1 && el.tagName !== 'SCRIPT' && el.tagName !== 'STYLE');
        }
        return items;
    }

    function rebuildProductWall(productsContainer) {
        let productList = findProductListNode(productsContainer);
        if (!productList) return;
        
        let new_list_node = [];

        for (let index = 0; index < ALPINE_IDS.length; index++) {
            let item = createProductListItem(ALPINE_IDS[index]);
            if (item) new_list_node.push(item);
        }

        productList.replaceChildren(...new_list_node);
    }

    function extendProductWall(productList) {
        if (!productList) return;
        
        let new_list_node = [];

        for (let index = 0; index < ALPINE_IDS.length; index++) {
            let item = createProductListItem(ALPINE_IDS[index]);
            if (item) new_list_node.push(item);
        }

        for (let node of new_list_node) {
            productList.appendChild(node);
        }
    }

    function createProductListItem(alpine_id) {
        if (!templates.product) return null;
        
        let element = templates.product.content.cloneNode(true);
        let cardElement = element.querySelector('card') || element.firstElementChild;
        if (!cardElement) return null;

        ui_substitution(alpine_id, cardElement);

        let finalElement = cardElement.querySelector(':scope > div') || cardElement;

        return finalElement;
    }


    function externalReferrer() {
        let match = /(?:^|;)\s*oscExternalRef\s*=\s*([^;]+)/.exec(document.cookie);

        if (match != null) return match[1];

        let a = document.createElement("a");

        a.href = document.referrer;

        if (a.host !== window.location.host) {
            document.cookie = "oscExternalRef=" + document.referrer + "; path=/";

            return document.referrer;
        }

        return null;
    }

    const cookieRE = new RegExp(oscClient.COOKIE_TRCK_PREFIX + '([0-9a-zA-Z]*?)=.*?;', 'g');

    function oscCookies(osc, callback) {
        let matches;
        cookieRE.lastIndex = 0;

        while ((matches = cookieRE.exec(document.cookie)) != null) {
            callback(matches[1], osc.cookie(oscClient.COOKIE_TRCK_PREFIX + matches[1]));
        }
    }

    function typeOf(arg) {
        return Object.prototype.toString.call(arg)
            .replace(/^\[object\s([^\]]+)\]$/, "$1").toLowerCase();
    }

    function transformFilterName(fullName, prefix) {
        let name = fullName.trim().replace(prefix, '');

        return `cr_${name}`;
    }

    function preloadImages(urlList) {
        let width = getImageWidth();

        for (let i = 0; i < urlList.length; i++) {
            let image = new Image(width);

            image.fetchPriority = (i < 2) ? 'high' : 'low';
            image.src = urlList[i];
        }
    }

    function revealProductCards() {
        oscClient.reveal();
    }


    function replaceLoadMoreHandler() {
        if (document.$oscLoadMoreCaptureAttached) return;

        document.addEventListener('click', function handleLoadMoreClickCapture(event) {
            let clickTarget = (event.target && event.target.nodeType === 1)
                ? event.target
                : event.target && event.target.parentElement;

            if (!clickTarget || typeof clickTarget.closest !== 'function') return;

            let button = clickTarget.closest('[data-load-more="button"]');
            if (!button) return;

            event.preventDefault();
            event.stopPropagation();

            button.type = 'button';
            button.setAttribute('type', 'button');
            button.setAttribute('osc-sign', null);

            loadMoreOdoscope();
        }, true);

        document.$oscLoadMoreCaptureAttached = true;
    }

    function updateUICounters() {
        let target = oscClient.getTargetNode();
        let retries = 0;

        function checkForCounters() {
            let filter_counter = target.querySelector('[li-render-custom-target="showing-count"]');

            if (filter_counter) {
                filter_counter.innerText = buildFilterCounterText(PRODUCT_LIST_STATE.current, PRODUCT_LIST_STATE.total);

                let bottom_counter = target.querySelector('[data-load-more="count-display"]');

                if (bottom_counter) {
                    bottom_counter.innerText = buildBottomCounterText(PRODUCT_LIST_STATE.current, PRODUCT_LIST_STATE.total);
                }
                return;
            }

            if (++retries < 120) {
                requestAnimationFrame(checkForCounters);
            }
        }

        requestAnimationFrame(checkForCounters);
    }


    function collect_filter_collection(params) {
        params[FILTER_COLLECTION] = getCID();
        params[PARAMETER_COLLECTION] = getCollectionHandle();
    }

    function collect_common_filters(params, query) {
        let count = 0;

        for (let key in FILTER_MAP) {
            if (!FILTER_MAP.hasOwnProperty(key)) continue;
            if (!query.has(key)) continue;

            count++;

            extend_param(params, FILTER_MAP[key], query.getAll(key));
        }

        return (count > 0);
    }

    function collect_product_specific_filters(params, query) {
        if (!Array.isArray(availableCustomFilters)) return false;

        let count = 0;

        for (let fullName of availableCustomFilters) {
            if (!query.has(fullName)) continue;

            if (fullName.startsWith(CUSTOM_PRODUCT_FILTER_PREFIX)) {
                count++;
                extend_param(params, transformFilterName(fullName, CUSTOM_PRODUCT_FILTER_PREFIX), query.getAll(fullName));
            }
            if (fullName.startsWith(CUSTOM_VARIANT_FILTER_PREFIX)) {
                count++;
                extend_param(params, transformFilterName(fullName, CUSTOM_VARIANT_FILTER_PREFIX), query.getAll(fullName));
            }
        }

        return (count > 0);
    }

    function extend_param(params, key, values) {
        if (values.length == 0) return;

        if (values.length == 1) {
            params[key] = decodeURIComponent(values[0]);
        }
        else {
            params[key] = values.map(decodeURIComponent).join('|');
        }
    }


    function getCID() {
        return window.Osc_ENV.collection_id;
    }

    function resolveCurrentLanguage() {
        if (!window.Shopify || typeof window.Shopify.locale !== 'string') return '';

        return window.Shopify.locale.trim().toLowerCase();
    }

    function getCollectionHandle() {
        return window.Osc_ENV.collection_handle;
    }

    function getImageWidth() {
        return Number(window.Osc_ENV.image_width);
    }

    function getSmallImageWidth() {
        return Number(window.Osc_ENV.small_image_width);
    }

    function getPossibleFilterNames() {
        let nameList = window.Osc_ENV.available_filters.split('|');
        if (nameList.length == 0) return null;

        nameList = nameList.filter(name => name.startsWith(BUILT_IN_FILTER_PREFIX));
        if (nameList.length == 0) return null;

        return nameList;
    }

    function getTotalProductNumber() {
        return Number(window.Osc_ENV.total_products);
    }

    /**
     * @returns {Array.<String>}
     */
    function getVisualOptionNames() {
        return window.Osc_ENV.visual_options;
    }

    function buildFilterCounterText(current, total) {
        return window.Osc_ENV.msg_results_count.replace('AAA', current).replace('BBB', total);
    }

    function buildBottomCounterText(current, total) {
        return window.Osc_ENV.msg_seen_products.replace('AAA', current).replace('BBB', total);
    }


    function removeWidthParam(url) {
        if (!url) return url;

        try {
            let parsed = new URL(url, window.location.origin);
            parsed.searchParams.delete('width');

            return parsed.toString();
        }
        catch (error) {
            return url
                .replace(/([?&])width=\d+(&?)/, (match, prefix, suffix) => {
                    if (prefix === '?' && suffix) return '?';
                    if (prefix === '&' && suffix) return '&';
                    return '';
                })
                .replace(/[?&]$/, '');
        }
    }

    function updateURLwithQuery(url, width) {
        if (!Number.isFinite(width) || width <= 0) return removeWidthParam(url);

        return `${url}&width=${width}`;
    }


    function ui_substitution(alpine_id, element) {
        replacePlaceholderInAttributes(element, alpine_id);

        let walker = document.createTreeWalker(element, 5);
        let node;

        while ((node = walker.nextNode()) !== null) {
            if (node.nodeType === 3) {
                if (node.nodeValue.indexOf(P_ALPINE_ID) !== -1) {
                    node.nodeValue = node.nodeValue.replaceAll(P_ALPINE_ID, alpine_id);
                }
            } else if (node.attributes) {
                replacePlaceholderInAttributes(node, alpine_id);
            }
        }
    }

    function replacePlaceholderInAttributes(el, alpine_id) {
        let attrs = el.attributes;
        if (!attrs) return;

        for (let i = 0; i < attrs.length; i++) {
            if (attrs[i].value.indexOf(P_ALPINE_ID) !== -1) {
                attrs[i].value = attrs[i].value.replaceAll(P_ALPINE_ID, alpine_id);
            }
        }
    }



    var trackingMessages = null;
    var GTAG_FN = null;
    var trackingTimeoutID = null;

    function pushTrackingEvent(group, trackingId) {
        if (GTAG_FN != null) {
            sendTrackingEvent(group, trackingId);
            return;
        }

        if (!Array.isArray(trackingMessages)) trackingMessages = [];

        trackingMessages.push([group, trackingId]);

        startWaitingForTracking();
    }

    function sendTrackingEvent(group, trackingId) {
        GTAG_FN.call(null, 'event', KEY_OSC, {
            'trackingGroup': group,
            'trackingId': trackingId
        });
    }

    function startWaitingForTracking() {
        if (trackingTimeoutID != null) window.clearTimeout(trackingTimeoutID);

        trackingTimeoutID = window.setTimeout(finishWaitingForTracking, 500);
    }

    function finishWaitingForTracking() {
        if (typeOf(window.gtag) == 'function') {
            GTAG_FN = window.gtag;
            trackingTimeoutID = null;

            for (let record of trackingMessages) {
                sendTrackingEvent.apply(context, record);
            }

            trackingMessages = null;
            return;
        }

        startWaitingForTracking();
    }


    function OscProduct() {
        this.id = null;
        this.url = null;      // product.url
        this.title = null;    // product.title
        this.imageUrl = null; // product.featured_image

        this.options = [];
        this.options_by_name = {};
        this.visual_variants = {};

        this.price = -1;            // actual price
        this.compare_at_price = -1; // original price

        this.badge1 = null;
        this.badge2 = null;

        this.isBestseller = false;
        this.canBeAddedToCard = false;
        this.canGoToProductPage = false;

        this.variants = [];

        this.$oscState = {
            firstVariant: -1,
            cheapestVariant: -1,
            selectedVariantIndex: -1,
            minPrice: -1,
            maxPrice: -1,
            urlPrefix: null,
            availableForSale: false // 'product.availableForSale'
        };

        var self = this;

        Object.defineProperties(self, {
            selected_or_first_available_variant: {
                get: function () {
                    if (self.$oscState.selectedVariantIndex != -1) {
                        return self.variants[self.$oscState.selectedVariantIndex];
                    }
                    if (self.$oscState.firstVariant == -1) return null;

                    return self.variants[self.$oscState.firstVariant];
                },
                set: function (variant) {
                    if (variant == null) {
                        self.$oscState.selectedVariantIndex = -1;
                        return;
                    }
                    for (let i = 0; i < self.variants.length; i++) {
                        if (self.variants[i].id === variant.id) {
                            self.$oscState.selectedVariantIndex = i;
                            return;
                        }
                    }
                    self.$oscState.selectedVariantIndex = -1;
                }
            }
        });
    }

    OscProduct.parseJsonRecord = function (j_product) {
        let product = new OscProduct();

        product.id = j_product.variantID;
        product.url = j_product.url;
        product.title = j_product.label;
        product.price = OscProduct.processPrice(j_product.price);
        product.imageUrl = j_product.imageLink;

        let v_info = j_product.variantInfo;

        product.badge1 = OscProduct.extractBadge(v_info, 1);
        product.badge2 = OscProduct.extractBadge(v_info, 2);

        product.isBestseller = v_info.isBestseller;

        product.options_by_name = OscProduct.parseOptions(v_info.options);
        product.options = Object.keys(product.options_by_name);

        product.$oscState.minPrice = OscProduct.processPrice(v_info.priceRangeMin);
        product.$oscState.maxPrice = OscProduct.processPrice(v_info.priceRangeMax);
        product.$oscState.urlPrefix = v_info.imageUrlPrefix;

        // Calculate max compare_at_price for fallback on unavailable variants
        let maxCompareAtPrice = 0;
        if (v_info.variantsCompareAtPrice) {
            const compareAtPrices = v_info.variantsCompareAtPrice.split(',').map(p => Number(p)).filter(p => Number.isFinite(p) && p > 0);
            if (compareAtPrices.length > 0) {
                maxCompareAtPrice = Math.max(...compareAtPrices);
            }
        }
        product.$oscState.maxCompareAtPrice = OscProduct.processPrice(maxCompareAtPrice);

        // special case: no available
        if (typeof v_info.variantIdsAvailable !== 'string' || v_info.variantIdsAvailable.trim().length === 0) {
            let possible_ids = OscProduct.getNumberList(v_info, 'variantsIds');
            let possible_skus = v_info.variantSKUs ? v_info.variantSKUs.split(DIVIDER) : [];
            let possible_images = v_info.imagesURLs ? v_info.imagesURLs.split(DIVIDER) : [];
            let possible_alt_texts = v_info.imagesAltTexts ? v_info.imagesAltTexts.split(DIVIDER) : [];

            let itself = new OscVariant(null, null, product.title);
            itself.stub(product, possible_ids, possible_skus, possible_images, possible_alt_texts);

            product.$oscState.firstVariant = 0;
            product.variants = [itself];

            product.visual_variants = { values: [] };
            product.canBeAddedToCard = false;
            product.canGoToProductPage = true;

            return product;
        }


        let v_all_ids = OscProduct.getNumberList(v_info, 'variantsIds');
        let v_av_ids = OscProduct.getNumberList(v_info, 'variantIdsAvailable');

        let avIndexById = new Map();
        for (let i = 0; i < v_av_ids.length; i++) {
            avIndexById.set(v_av_ids[i], i);
        }

        let v_titles = null,
            has_titles = false;

        try {
            v_titles = JSON.parse(v_info.variantsTitle);
            has_titles = true;

            if (Array.isArray(v_titles) && v_titles.length !== v_all_ids.length && v_titles.length === v_av_ids.length) {
                v_titles = v_all_ids.map((variantId) => {
                    let avIndex = avIndexById.get(variantId);
                    return (avIndex == null ? null : v_titles[avIndex]);
                });
            }
        }
        catch (e) { }

        let __id2sku = OscProduct.buildID2SKU_map(v_info);

        let v_quantities = OscProduct.getValuesListAligned(v_info, v_all_ids, avIndexById, 'variantsQuantityAvailable', 0, Number);
        let v_prices = OscProduct.getValuesListAligned(v_info, v_all_ids, avIndexById, 'variantsPrice', null, Number);

        let v_compare_at_prices = OscProduct.getValuesListAligned(v_info, v_all_ids, avIndexById, 'variantsCompareAtPrice', null, Number);

        let v_feature_images = OscProduct.getValuesListAligned(v_info, v_all_ids, avIndexById, 'variantsFeatureImages', null);
        let v_feature_images_alt = OscProduct.getValuesListAligned(v_info, v_all_ids, avIndexById, 'variantsFeatureImageAltText', '');

        let v_images = (Array.isArray(v_info.variantsImageLinks) ? v_info.variantsImageLinks : Array(v_all_ids.length).fill(null));
        v_images = alignArray(v_images, v_all_ids, avIndexById, null);

        let v_available_flags = OscProduct.getAvailabilityFlags(v_info, v_all_ids, avIndexById);
        let v_not_in_stock_flags = OscProduct.getValuesListAligned(v_info, v_all_ids, avIndexById, 'variantsCurrentlyNotInStock', true, OscProduct.parseBoolean);

        let v_selected_options = v_info.variantsSelectedOptions;
        if (Array.isArray(v_selected_options)) {
            v_selected_options = alignArray(v_selected_options, v_all_ids, avIndexById, null);
        }

        let available_variant_map = new Map();
        let all_variant_map = new Map();
        let index_over_sku = {};

        // Build SKU to options mapping from v_info.options for unavailable variants
        let skuToOptions = new Map();
        if (Array.isArray(v_info.options)) {
            for (let opt of v_info.options) {
                for (let val of opt.values) {
                    if (val.variant?.sku) {
                        if (!skuToOptions.has(val.variant.sku)) {
                            skuToOptions.set(val.variant.sku, []);
                        }
                        skuToOptions.get(val.variant.sku).push({ name: opt.name, value: val.name });
                    }
                }
            }
        }

        product.variants = Array(v_all_ids.length).fill(null);

        for (let index = 0; index < v_all_ids.length; index++) {
            let variant_id = v_all_ids[index];
            let variant_sku = __id2sku.get(variant_id);

            let p_variant = new OscVariant(
                variant_id,
                variant_sku,
                (has_titles && v_titles[index] ? v_titles[index] : product.title)
            );

            // Use skuToOptions as fallback for unavailable variants
            let selected_options_for_variant = v_selected_options[index];
            if (!selected_options_for_variant && variant_sku && skuToOptions.has(variant_sku)) {
                selected_options_for_variant = skuToOptions.get(variant_sku);
            }

            p_variant.fill(
                product,
                v_feature_images[index],
                v_feature_images_alt[index],
                v_images[index],
                v_quantities[index],
                v_prices[index],
                v_compare_at_prices[index],
                v_available_flags[index],
                v_not_in_stock_flags[index],
                selected_options_for_variant
            );

            product.variants[index] = p_variant;

            if (!!p_variant.sku) {
                all_variant_map.set(p_variant.sku, p_variant);
                index_over_sku[p_variant.sku] = index;
            }

            product.$oscState.availableForSale ||= p_variant.available;

            if (p_variant.available) {
                if (product.$oscState.firstVariant == -1) {
                    product.$oscState.firstVariant = index;
                }

                if (!!p_variant.sku) {
                    available_variant_map.set(p_variant.sku, p_variant);
                }

                if (product.$oscState.cheapestVariant == -1) {
                    if (p_variant.price == product.$oscState.minPrice) {
                        product.$oscState.cheapestVariant = index;
                    }
                }
            }
        }

        OscProduct.sortOptionValuesByAvailability(product);

        if (product.$oscState.cheapestVariant != -1) {
            product.$oscState.firstVariant = product.$oscState.cheapestVariant;
        }


        let visual_variants = OscProduct.buildVisualVariantList(all_variant_map, v_info.options);

        if (visual_variants == null) {
            product.visual_variants = { values: [] };

            product.canBeAddedToCard = product.$oscState.availableForSale && available_variant_map.size <= 1;
            product.canGoToProductPage = !product.$oscState.availableForSale || available_variant_map.size > 1;
        }
        else {
            if (product.$oscState.cheapestVariant == -1) {
                // the first available variant from the first visual option
                if (Array.isArray(visual_variants.values) && visual_variants.values.length > 0) {
                    let first_available_visual = visual_variants.values.find(v => v && v.available && !!v.sku);
                    let first_visual = first_available_visual || visual_variants.values.find(v => v && !!v.sku);
                    if (first_visual) {
                        product.$oscState.firstVariant = index_over_sku[first_visual.sku];
                    }
                }
            }

            product.visual_variants = visual_variants;

            product.canBeAddedToCard = product.$oscState.availableForSale && visual_variants.visual_variation_num <= 1;
            product.canGoToProductPage = !product.$oscState.availableForSale || visual_variants.visual_variation_num > 1;
        }

        return product;
    };

    OscProduct.extractBadge = function (j_product, index) {
        let name = `badge_${index}`;

        if (!j_product[name]) return null;

        return {
            color: j_product[name].Color || window.Osc_ENV.badge_color,
            bg_color: j_product[name].BgColor || window.Osc_ENV.badge_bg_color,
            text: j_product[name].Text
        };
    };

    /**
     * @param {Array.<{name: String, values: Array.<{name: String, firstSelectableVariant: {sku: String}}>}>} j_options
     */
    OscProduct.parseOptions = function (j_options) {
        let output = {};

        for (let r_option of j_options) {
            output[r_option.name] = {
                option: {
                    values: r_option.values.map(opt_value => opt_value.name)
                },
                valuesToSku: {}
            };
            for (let opt_value of r_option.values) {
                output[r_option.name].valuesToSku[opt_value.name] = opt_value.variant?.sku;
            }
        }

        return output;
    };

    OscProduct.sortOptionValuesByAvailability = function (product) {
        if (!product || !product.options_by_name || !Array.isArray(product.options) || !Array.isArray(product.variants)) {
            return;
        }

        for (let optionName of product.options) {
            let optionRecord = product.options_by_name[optionName];
            if (!optionRecord || !optionRecord.option || !Array.isArray(optionRecord.option.values)) continue;

            let optionIndex = product.options.indexOf(optionName) + 1;
            if (optionIndex <= 0) continue;

            optionRecord.option.values = optionRecord.option.values
                .map(function (optionValue, originalIndex) {
                    let hasAvailableVariant = product.variants.some(function (variant) {
                        return !!variant && !!variant.available && variant[`option${optionIndex}`] === optionValue;
                    });

                    return {
                        optionValue: optionValue,
                        originalIndex: originalIndex,
                        hasAvailableVariant: hasAvailableVariant
                    };
                })
                .sort(function (left, right) {
                    if (left.hasAvailableVariant === right.hasAvailableVariant) {
                        return left.originalIndex - right.originalIndex;
                    }

                    return left.hasAvailableVariant ? -1 : 1;
                })
                .map(function (item) { return item.optionValue; });
        }
    };

    /**
     * @param {Object} v_info
     * @param {Number} idsNumber
     * @param {String} targetField
     * @param {any} defValue
     * @param {Function} _type_
     * @return {Array.<any>}
     */
    OscProduct.getValuesList = function (v_info, idsNumber, targetField, defValue, _type_ = null) {
        if (!!v_info[targetField]) {
            if (_type_ == null) return v_info[targetField].split(DIVIDER);

            return v_info[targetField].split(DIVIDER).map(value => _type_(value));
        }

        return Array(idsNumber).fill(defValue);
    };

    function alignArray(raw, allIds, avIndexById, defValue) {
        if (!Array.isArray(raw)) return Array(allIds.length).fill(defValue);
        if (raw.length === allIds.length) return raw;

        if (raw.length === avIndexById.size) {
            return allIds.map(function (variantId) {
                let avIndex = avIndexById.get(variantId);
                return (avIndex == null ? defValue : raw[avIndex]);
            });
        }

        if (raw.length < allIds.length) {
            return raw.concat(Array(allIds.length - raw.length).fill(defValue));
        }

        return raw.slice(0, allIds.length);
    }

    OscProduct.getValuesListAligned = function (v_info, allIds, avIndexById, targetField, defValue, _type_ = null) {
        let raw = OscProduct.getValuesList(v_info, 0, targetField, defValue, _type_);

        return alignArray(raw, allIds, avIndexById, defValue);
    };

    /**
     * @param {Object} v_info
     * @param {String} targetField
     * @return {Array.<Number>}
     */
    OscProduct.getNumberList = function (v_info, targetField) {
        if (!v_info[targetField]) return [];
        return v_info[targetField].split(DIVIDER).map(str => Number(str));
    };

    /**
     * @param {Object} v_info
     * @return {Map<Number, String>}
     */
    OscProduct.buildID2SKU_map = function (v_info) {
        let output = new Map();

        if (!v_info.variantSKUs) return output;

        let v_skus = v_info.variantSKUs.split(DIVIDER);
        let v_ids = OscProduct.getNumberList(v_info, 'variantsIds');

        for (let index = 0; index < v_ids.length; index++) {
            output.set(v_ids[index], v_skus[index]);
        }

        return output;
    };

    OscProduct.processPrice = function (inPrice) {
        return Number(inPrice) * 100;
    }

    OscProduct.parseBoolean = function (value) {
        if (typeof value === 'boolean') return value;
        if (value == null) return false;

        let normalized = String(value).trim().toLowerCase();
        if (normalized.length === 0) return false;

        if (normalized === 'true') return true;
        if (normalized === 'false') return false;

        if (normalized === '1') return true;
        if (normalized === '0') return false;

        return false;
    }

    OscProduct.getAvailabilityFlags = function (v_info, allIds, avIndexById) {
        if (v_info.variantsAvailableForSale) {
            let raw = v_info.variantsAvailableForSale.split(DIVIDER).map(OscProduct.parseBoolean);

            return alignArray(raw, allIds, avIndexById, false);
        }

        return allIds.map(function (variantId) { return avIndexById.has(variantId); });
    }

    OscProduct.buildVisualVariantList = function (variant_map, j_options) {
        if (variant_map.size == 0) return null;
        if (j_options.length == 0) return null;

        let p_names = new Set(j_options.map(option => option.name));
        let o_names = new Set(getVisualOptionNames() || []);

        let intersected = new Set();
        for (let name of o_names) {
            if (p_names.has(name)) {
                intersected.add(name);
            }
        }

        if (intersected.size == 0) return null;

        p_names = Array.from(intersected);


        var output = {
            values: [],
            used_option_name: null,
            additional_count: 0,
            visual_variation_num: 0
        };

        let target_prefix = updateURLwithQuery('', getImageWidth()),
            width = getSmallImageWidth();

        for (let visual_option_name of p_names) {
            for (let r_option of j_options) {
                if (r_option.name != visual_option_name) continue;

                let prev_len = output.values.length;

                for (let r_value of r_option.values) {
                    let r_id = r_value.variant?.sku;

                    if (!r_id) continue;
                    if (!variant_map.has(r_id)) continue;

                    if (output.values.length >= VARIANT_LIMIT) {
                        output.additional_count += 1;
                        continue;
                    }

                    let r_variant = variant_map.get(r_id);

                    if (!r_variant.available) {
                        let available_variant_for_option = null;
                        for (let [sku, variant] of variant_map) {

                            if (variant.available &&
                                (variant.option1 === r_value.name ||
                                    variant.option2 === r_value.name ||
                                    variant.option3 === r_value.name)) {
                                available_variant_for_option = variant;
                                break;
                            }
                        }
                        if (available_variant_for_option) {
                            r_variant = available_variant_for_option;
                        }
                    }

                    r_variant = r_variant.clone();

                    r_variant.option_value = r_value.name;

                    r_variant.image.url = r_variant.image.url.replace(target_prefix, '');
                    r_variant.image.url = updateURLwithQuery(r_variant.image.url, width);

                    output.values.push(r_variant);
                }

                if (prev_len != output.values.length) {
                    output.visual_variation_num += 1;
                }
            }

            if (output.used_option_name == null && output.values.length > 0) {
                output.used_option_name = visual_option_name;
            }
        }

        return output;
    };

    OscProduct.prototype.getAlpineID = function () {
        return `osc_${this.id}`;
    };


    function OscVariant(vid, sku, title) {
        this.id = vid;
        this.sku = sku;
        this.title = title;

        this.image = null;
        this.hoverImage = null;

        this.inventory_quantity = -1;
        this.price = 0;
        this.compare_at_price = 0;

        this.available = false;
        this.not_in_stock = false;

        this.option1 = null;
        this.option2 = null;
        this.option3 = null;
    }

    OscVariant.prototype.clone = function () {
        return Object.assign(new OscVariant(), this);
    };

    /**
     * @param {OscProduct} product
     * @param {String|null} feature_image
     * @param {String|null} feature_image_alt
     * @param {Array|null} images
     * @param {String|Number} quantity
     * @param {String|Number} price
     * @param {String|Number} compare_at_price
     * @param {Boolean} available
     * @param {Boolean} not_in_stock
     * @param selected_options
     */
    OscVariant.prototype.fill = function (
        product,
        feature_image,
        feature_image_alt,
        images,
        quantity,
        price,
        compare_at_price,
        available,
        not_in_stock,
        selected_options
    ) {
        let width = getImageWidth();

        this.image = { url: product.imageUrl, altText: product.title };
        this.hoverImage = { url: null, altText: product.title };

        feature_image = String(feature_image).trim();

        if (feature_image.length > 0) {
            this.image.url = product.$oscState.urlPrefix + feature_image;
            this.image.altText = feature_image_alt || this.title;
        }

        if (Array.isArray(images)) {
            if (images.length > 0) {
                this.image.url = product.$oscState.urlPrefix + images[0].url;
                this.image.altText = images[0].txt || this.title;
            }

            this.image.url = updateURLwithQuery(this.image.url, width);

            for (let index = 1; index < images.length; index++) {
                if (images[index].t == 'video') continue;

                this.hoverImage.url = updateURLwithQuery(product.$oscState.urlPrefix + images[index].url, width);
                this.hoverImage.altText = images[index].txt || this.title;

                break;
            }
        }

        if (!this.hoverImage.url) {
            this.hoverImage.url = this.image.url;
        }

        // prices are obtained in EUR
        let parsedPrice = Number(price);
        if (Number.isFinite(parsedPrice) && parsedPrice > 0) {
            this.price = OscProduct.processPrice(parsedPrice);
        }
        else {
            this.price = (product.$oscState.minPrice > 0 ? product.$oscState.minPrice : product.price);
        }

        let parsedCompareAtPrice = Number(compare_at_price);
        if (Number.isFinite(parsedCompareAtPrice) && parsedCompareAtPrice > 0) {
            this.compare_at_price = OscProduct.processPrice(parsedCompareAtPrice);
        }
        else {
            // Use maxCompareAtPrice as fallback for unavailable variants
            this.compare_at_price = product.$oscState.maxCompareAtPrice > 0 ? product.$oscState.maxCompareAtPrice : 0;
        }

        this.inventory_quantity = Number(quantity);
        this.available = available;
        this.not_in_stock = not_in_stock;

        if (Array.isArray(selected_options)) {
            for (let index = 0; index < selected_options.length; index++) {
                this[`option${index + 1}`] = selected_options[index].value;
            }
        }
        else if (this.title && this.title.includes(' / ')) {
            const optionParts = this.title.split(' / ');
            for (let index = 0; index < optionParts.length; index++) {
                this[`option${index + 1}`] = optionParts[index].trim();
            }
        }
    };

    /**
     * @param {OscProduct} product
     * @param {Array.<Number>} possible_ids
     * @param {Array.<String>} possible_skus
     * @param {Array.<String>} possible_images
     * @param {Array.<String>} possible_alt_texts
     */
    OscVariant.prototype.stub = function (
        product,
        possible_ids,
        possible_skus,
        possible_images,
        possible_alt_texts
    ) {
        this.price = product.$oscState.maxPrice;

        this.image = { url: product.imageUrl, altText: product.title };
        this.hoverImage = { url: null, altText: product.title };

        if (possible_ids.length > 0) {
            this.id = possible_ids[0];

            if (possible_skus.length > 0) {
                this.sku = possible_skus[0];
            }

            let step = possible_ids.length;

            /* ['sku_1_image1', 'sku_2_image1', 'sku_3_image1', 'sku_1_image2', 'sku_2_image2', 'sku_3_image2'] */

            if (possible_images.length > 0) {
                this.image.url = product.$oscState.urlPrefix + possible_images[0];

                if (possible_images.length >= step) {
                    this.hoverImage.url = product.$oscState.urlPrefix + possible_images[step];
                }
            }

            if (possible_alt_texts.length > 0) {
                this.image.altText = possible_alt_texts[0];

                if (possible_alt_texts.length >= step) {
                    this.hoverImage.altText = possible_alt_texts[step];
                }
            }
        }

        let width = getImageWidth();

        if (this.image.url != null) this.image.url = updateURLwithQuery(this.image.url, width);
        if (this.hoverImage.url != null) this.hoverImage.url = updateURLwithQuery(this.hoverImage.url, width);
    };

})(window, document);
